import { useQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'

export const useBeamerUnreadCount = ({ enabled }: { enabled: boolean }) => {
  const userData = useAuthenticatedUser()

  const { data, refetch } = useQuery({
    queryKey: ['beamer', 'unread-count'],
    enabled: enabled && userData.isFullyAuthenticated,
    queryFn: async () => {
      const res = await fetch('/api/beamer/unread-count')
      if (!res.ok) return { count: 0 }
      return res.json() as Promise<{ count: number }>
    },
  })

  return { unreadCount: data?.count ?? 0, refetchUnreadCount: refetch }
}
